import React, { useEffect, useState } from "react";
import "./CopyUrl.css";
import InfoPopup from "../../CommonComponents/InfoPopup/InfoPopup";
import { toastify } from "../../../../helpers/toast/toastify";
import copyIcon from "../../../../assets/images/Copy.svg";
import { useDispatch, useSelector } from "react-redux";
import CustomSwitch from "../../CommonComponents/CustomSwitch/CustomSwitch";
import useApi from "../../../../helpers/apiHelper/requestHelper";
import { setRefetchSpecificUser } from "../../../../redux/multicommunity/multicommunity.js";

const CopyUrl = () => {
  const [leaderCommunityName, setLeaderCommunityName] = useState("");
  const { user } = useSelector((state) => state.user);
  const [isChecked, setIsChecked] = useState(true);
  const [marketPlaceChecked, setMarketPlaceChecked] = useState(false);
  const api = useApi();
  const dispatch = useDispatch();

  useEffect(() => {
    setLeaderCommunityName(user?.leaderCommunity?.name);
  }, [user]);

  useEffect(() => {
    if (user) {
      setIsChecked(user?.leaderCommunity?.allowPublicReviews);
      setMarketPlaceChecked(user?.leaderCommunity?.showInMarketTrade);
    }
  }, [user]);

  const publicReviewOnChange = async () => {
    // Store the current state for potential rollback
    const previousState = isChecked;

    // Optimistically update the UI immediately
    setIsChecked(!isChecked);

    try {
      const response = await api(
        "post",
        "communityReview/togglePublicReviewVisibility",
        {
          allowPublicReviews: !previousState,
        }
      );

      if (response?.status) {
        // API success - update user data and show success message
        dispatch(setRefetchSpecificUser(true));
        toastify(
          `Reviews and performance ${
            previousState ? "not" : "now"
          } showing on your landing page`,
          "success"
        );
      } else {
        // API returned error status - revert the optimistic update
        setIsChecked(previousState);
        toastify(
          response?.message || "Failed to update review visibility",
          "error"
        );
      }
    } catch (error) {
      // API call failed - revert the optimistic update
      setIsChecked(previousState);
      toastify(
        "Failed to update review visibility. Please try again.",
        "error"
      );
      console.log("error", error);
    }
  };

  const marketPlaceOnChange = async () => {
    // Store the current state for potential rollback
    const previousState = marketPlaceChecked;

    // Optimistically update the UI immediately
    setMarketPlaceChecked(!marketPlaceChecked);

    try {
      const response = await api(
        "post",
        "community/updateMarketTradeVisibility",
        {
          communityId: user?.leaderCommunity?._id,
          showInMarketTrade: !previousState,
        }
      );

      if (response?.status) {
        dispatch(setRefetchSpecificUser(true));
        toastify(
          `Community ${previousState ? "not" : "now"} showing on Market Place`,
          "success"
        );
      } else {
        // API returned error status - revert the optimistic update
        setMarketPlaceChecked(previousState);
        toastify(
          response?.message || "Failed to update market trade visibility",
          "error"
        );
      }
    } catch (error) {
      // API call failed - revert the optimistic update
      setMarketPlaceChecked(previousState);
      toastify(
        "Failed to update market trade visibility. Please try again.",
        "error"
      );
      console.log("error", error);
    }
  };

  return (
    <>
      <div className="copyUrlBox">
        <div className="row align-items-center copyURLWrapper">
          <div className="col-lg-6 col-md-6 col-12">
            <div className="titleWrapper">
              <p className="title">Copy Trade Service URL</p>
              <InfoPopup
                contentItems={[
                  { type: "heading", text: "Copy Trade Service URL" },
                  {
                    type: "paragraph",
                    text: "This is your unique page where members can join your copy trading service.",
                  },
                ]}
              />
            </div>
            <p className="subTitle">
              Sign up page for your community
            </p>
          </div>
          <div className="col-lg-6 col-md-6 col-12">
            <div className="UrlBox">
              <div className="UrlBoxInner">
                <input
                  type="text"
                  className="setformfontsize14"
                  value={`${document.location.origin.replace(
                    document.location.pathname,
                    ""
                  )}/community/${leaderCommunityName?.split(" ").join("")}`}
                  disabled
                />
                <span className="copyIcon">
                  <img
                    className="cursor-pointer"
                    onClick={() => {
                      // Construct the community link using template literals
                      const communityLink = `${document.location.origin.replace(
                        document.location.pathname,
                        ""
                      )}/community/${leaderCommunityName?.split(" ").join("")}`;

                      // Attempt to copy the link to the clipboard
                      navigator.clipboard
                        .writeText(communityLink)
                        .then(() => {
                          // Success: Show a toast notification
                          toastify(
                            "Community link copied to clipboard!",
                            "success"
                          );
                        })
                        .catch((error) => {
                          // Error: Handle clipboard write failure and show a toast notification
                          console.error("Clipboard write error:", error);
                          toastify(
                            "Failed to copy community link to clipboard.",
                            "error"
                          );
                        });
                    }}
                    src={copyIcon}
                  />
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-12 col-12 mt-d">
            <div className="copyTradelandingPageReview">
              <CustomSwitch
                checked={marketPlaceChecked}
                onChange={marketPlaceOnChange}
              />
              <p className="reviewtitle">
                <span>Feature Service on Market Place</span>
                <InfoPopup
                  contentItems={[
                    { text: "Market Place", type: "heading" },
                    {
                      text: "Show your reviews and verified performance publicly in the marketplace.",
                      type: "paragraph",
                    },
                  ]}
                />
              </p>
            </div>

            <div
              className="copyTradelandingPageReview mt-d"
            >
              <CustomSwitch
                checked={isChecked}
                onChange={publicReviewOnChange}
              />
              <p className="reviewtitle">
                <span>Show reviews and performance on landing page</span>
                <InfoPopup
                  contentItems={[
                    { text: "Reviews", type: "heading" },
                    {
                      text: "Showing reviews and performance on your landing page tends to improve conversion.",
                      type: "paragraph",
                    },
                  ]}
                />
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CopyUrl;
